import type { NClients } from '@app/types/Clients';

export const WAITING = 'waiting';
export const CONFIRMED = 'confirmed';
export const VISITED = 'visited';
export const NOVISIT = 'novisit';

export const WAIT = 'Wait';
export const IN_PROGRESS = 'InProgress';
export const COMPLETED = 'Completed';
export const EXPIRED = 'Expired';
export const COMPLETED_EXPIRATION = 'CompletedExpiration';

export const WAITING_LABEL = 'Ожидание клиента';
export const CONFIRMED_LABEL = 'Клиент подтвердил';
export const VISITED_LABEL = 'Клиент пришел';
export const NOVISIT_LABEL = 'Клиент не пришел';

export const CLIENT_STATUSES: Array<{
  id: NClients.Status;
  label: string;
}> = [
  {
    id: WAITING,
    label: WAITING_LABEL,
  },
  {
    id: CONFIRMED,
    label: CONFIRMED_LABEL,
  },
  {
    id: VISITED,
    label: VISITED_LABEL,
  },
  {
    id: NOVISIT,
    label: NOVISIT_LABEL,
  },
];
